import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../service/auth.service';
import { Router } from '@angular/router';
interface Admin {
  uid: string;
  email: string;
  catchPhrase?: string;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})

export class LoginComponent implements OnInit {
  email: any;
  password: any;
  admin: Observable<Admin>;
  error: Boolean = false;
  constructor(private auth: AuthService, private router:Router) { }

  ngOnInit() {
  }
  async userlogin() {
    this.error = false;
    console.log(this.email,this.password)
    this.auth.loginadmin(this.email, this.password)
    .then(data => {
     setTimeout(() => {
     // window.location.reload()
     }, 2000);
    },
    error => {
      this.error = true;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts